import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { TagItem } from './TagItem';

const StyledMoreTagBox = styled(Box)({
  position: 'absolute',
  height: '28px',
  width: '38px',
  borderRadius: '50px',
  boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1)',
});

export const MoreTagItem = () => (
  <Box
    sx={{
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      paddingLeft: '18px',
    }}
  >
    <Box
      sx={{
        zIndex: 2,
        borderRadius: '50px',
        boxShadow: '5px 0px 15px -5px rgba(0, 0, 0, 0.2)',
      }}
    >
      <TagItem tag="More" />
    </Box>
    <StyledMoreTagBox sx={{ backgroundColor: 'background.boxDarker', right: 15, zIndex: 1 }} />
    <StyledMoreTagBox sx={{ backgroundColor: 'background.boxDarkest', right: 8 }} />
  </Box>
);
